var React = require('react');
var Extras = require('../../../data/extras.json');
var Stamper = require('../_common/Stamper');

var spritesHelper = require('../../../lib/spritesHelper');

var StamperTitrisation = React.createClass({

    propTypes: {
        index: React.PropTypes.number,
        play: React.PropTypes.bool,
        storyWidth: React.PropTypes.number,
        storyHeight: React.PropTypes.number,
        width: React.PropTypes.number,
        height: React.PropTypes.number,
        border: React.PropTypes.number,
        objs: React.PropTypes.object,
        container: React.PropTypes.object,
        backgroundKey: React.PropTypes.string,
        movieclipKey: React.PropTypes.string
    },

    contextTypes: {
        language: React.PropTypes.string,
    },

    getDefaultProps: function()
    {
        return {
            texts: [
                {
                    title: 'Sandra Li',
                    subtitle: 'Gestionnaire de contrôle',
                    opts: {
                        align: 'right',
                        x: 1040,
                        y: 145,
                    },
                },
            ],

            backgroundKey: 'stamperBg',
            movieclipKey: 'stampGirl',
            className: 'stamper-girl',
            blobsRow: 2,
            showBottomTreadmill: true,
            // The keys for the extra texts
            title: 'sandra',
            role: 'sandra_title',
        }
    },

    render: function()
    {
        const texts = _.merge(this.props.texts, [
            {
                title: Extras[this.props.title].text[this.context.language],
                subtitle: Extras[this.props.role].text[this.context.language],
            },
        ]);

        return (
            <Stamper
                {...this.props}
                texts={texts}
            />
        );
    }
});

module.exports = StamperTitrisation;



// WEBPACK FOOTER //
// ./js/components/frames/B-Titrisation/4-Stamper.jsx